import {validateField, clearFields} from './helpers/form'
import {
  CLEAR_VOICE_TEST_CANDIDATE_SEARCH_FIELDS,
  VALIDATE_VOICE_TEST_CANDIDATE_SEARCH_FIELD
} from '../../../actions/pages/voice-test-page'

export function voiceTestCandidateSearch (
  state = {
    valid: false,
    fields: [
      {
        name: 'SearchText',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Search text'
        }
      }
    ]
  },
  action
) {
  switch (action.type) {
    case VALIDATE_VOICE_TEST_CANDIDATE_SEARCH_FIELD: {
      return validateField(state, action);
    }

    case CLEAR_VOICE_TEST_CANDIDATE_SEARCH_FIELDS: {
      return clearFields(state);
    }

    default:
      return state
  }
}
